/**
 * Métodos para enviar e receber comandos
 * @type {Object}
 */
MdHub.command = {
  callbacks: {}, // Lista de callbacks aguardando a resolução da promessa
  commandId: 0, // Variável incremental de referência de comandos
  list: {}, // Lista de comandos.

  /**
   * Adiciona um novo comando
   * @param {String}   name     Nome do comando
   * @param {Function} callback Função a ser executada ao termino da promessa
   */
  add: function add(name, callback) {
    if (!name || !callback) {
      throw new Error('É necessário informar os parametros: name, callback');
    }

    this.list[name] = callback;
  },

  /**
   * Alias para o comando ping
   * @param {String}   target     Nome do módulo a ser checado
   */
  ping: function ping(target) {
    if (!target) {
      throw new Error('O parametro "target" é obrigatório');
    }

    return this.send(target, 'core:ping');
  },

  /**
   * Callback de rejeição de uma promessa
   * @param  {Object} message      Objeto contendo parametros de uma mensagem
   * @param  {Object} responseData Objeto que será entregue ao requisitor da promessa
   */
  reject: function reject(message, responseData) {
    var id;
    var name;
    var to;

    if (!message) {
      throw new Error('O parametro "message" é obrigatório');
    }

    id = message.id;
    name = message.name;
    to = message.from;

    MdHub.postMessage.send({
      callback: 'reject',
      data: responseData,
      id: id,
      name: name,
      to: to,
      type: 'command'
    });
  },

  /**
   * Remove um comando
   * @param  {String} name Nome do comando
   */
  remove: function remove(name) {
    if (!name) {
      throw new Error('O parametro "name" é obrigatório');
    }

    delete this.list[name];
  },

  /**
   * Callback de resolução de uma promessa
   * @param  {Object} message      Objeto contendo parametros de uma mensagem
   * @param  {Object} responseData Objeto que será entregue ao requisitor da promessa
   */
  resolve: function resolve(message, responseData) {
    var hash;
    var messageCallback;

    if (!message) {
      throw new Error('O parametro "message" é obrigatório');
    }

    messageCallback = {
      callback: 'resolve',
      data: responseData,
      from: MdHub.module.name,
      id: message.id,
      name: message.name,
      to: message.from,
      type: 'command',
      version: MdHub.module.version + '.' + MdHub.module.build
    };

    // Se for uma mensagem segura, o callback também será seguro
    if (message.secure && MdHub.hasStorage()) {
      // Não usar apenas o Date.now(), risco de colisão de mensagens gravando no sessionStorage
      // Não usar apenas module.name e id, risco de previsibilidade de dados no sessionStorage
      hash = Date.now().toString() + MdHub.module.name + message.id.toString();
      sessionStorage.setItem(hash, JSON.stringify(responseData));

      messageCallback.data = hash;
      messageCallback.secure = true;
    }

    MdHub.postMessage.send(messageCallback);
  },

  /**
   * Envia um comando
   * @param  {String} commandTarget Quem vai receber o comando
   * @param  {String} commandName   Nome do comando
   * @param  {Object} commandData   Dados enviados junto com o comando
   * @return {Object}               Retorna uma promessa
   */
  send: function send(commandTarget, commandName, commandData, secure) {
    var hash;
    // Formato padrão de mensagem de comando
    var message = {
      data: commandData,
      from: MdHub.module.name,
      id: (this.commandId += 1),
      name: commandName,
      to: commandTarget,
      type: 'command',
      version: MdHub.module.version + '.' + MdHub.module.build
    };

    var promise = {
      then: function then(resolve, reject) {
        this.resolve = resolve;
        this.reject = reject;
      },
      reject: function reject() {},
      resolve: function resolve() {}
    };

    if (commandTarget === undefined || commandName === undefined) {
      throw new Error('É necessário informar os parametros: commandTarget, commandName');
    }

    MdHub.command.callbacks[this.commandId] = promise;

    if (secure && MdHub.hasStorage()) {
      // Não usar apenas o Date.now(), risco de colisão de mensagens gravando no sessionStorage
      // Não usar apenas module.name e id, risco de previsibilidade de dados no sessionStorage
      hash = Date.now().toString() + MdHub.module.name + message.id.toString();
      sessionStorage.setItem(hash, JSON.stringify(commandData));

      message.data = hash;
      message.secure = true;
    }

    MdHub.postMessage.send(message);

    return promise;
  }
};
